<template>
  <main class="ref-page ref-page--soft">
    <PageHeader :title="$t('frontend.game.title')" :service="false" warm />
    <!-- <div v-if="categories.length" class="ref-tabs" role="tablist"><button role="tab" :aria-selected="active === 0" @click="select(0)">{{ $t('index.all') }}</button><button v-for="(item, index) in categories" :key="item.id || index" role="tab" :aria-selected="active === index + 1" @click="select(index + 1)">{{ item.name }}</button></div> -->
    <section v-if="loading" class="ref-game-grid"><div v-for="n in 4" :key="n" class="ref-game-card"><van-loading color="#b796c4" /></div></section>
    <LoadState v-else-if="error" :error="error" @retry="load" />
    <section v-else-if="games.length" class="ref-game-grid">
      <button v-for="item in games" :key="item.id || item.key" class="ref-game-card" @click="open(item)">
        <img v-if="imageUrl(item.ico) && !item.failed" :src="imageUrl(item.ico)" :alt="item.name" @error="$set(item, 'failed', true)">
        <span v-else class="ref-game-card__icon"><van-icon name="apps-o" /></span>
        <strong>{{ item.name || $t('frontend.game.item') }}</strong><small>{{ item.desc }}</small>
      </button>
    </section>
    <LoadState v-else :empty="$t('frontend.game.empty')" />
  </main>
</template>
<script>
import PageHeader from "../../common/PageHeader";
import LoadState from "../../common/LoadState";
import { assertResponse, imageUrl, rowsOf } from "../../common/reference";
export default {
  components: { PageHeader, LoadState },
  data: () => ({ games: [], categories: [], active: 0, loading: false, error: "", requestId: 0 }),
  methods: {
    imageUrl,
    select(index) { this.active = index; this.load(); },
    async load() {
      const request = ++this.requestId;
      this.loading = true; this.error = "";
      try {
        const result = assertResponse(await this.$http({ method: "get", url: "lottery_list", data: { class: this.active } }));
        if (request === this.requestId) this.games = rowsOf(result);
      } catch (error) { if (request === this.requestId) this.error = error.message || this.$t('frontend.game.load_failed'); }
      finally { if (request === this.requestId) this.loading = false; }
    },
    open(item) {
      if (!localStorage.getItem("token")) return this.$router.push("/Login");
      this.$router.push({ path: "/Lottery", query: { key: item.key, id: item.id } });
    }
  },
  created() {
    this.load();
    this.$http({ method: "get", url: "lottery_class" }).then(res => { this.categories = rowsOf(assertResponse(res)); }).catch(() => {});
  }
};
</script>
